module.exports = __webpack_public_path__ + "img/flash.20760c1b.svg";